import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

/**
 * Tenant Admins manage their tenant's service accounts here. The tenant is a
 * `?tenant=` query parameter, as on Policy administration, and defaults to the
 * first tenant the caller administers.
 */
const serviceAccountsPage = PageBlueprint.make({
  name: 'service-accounts',
  params: {
    path: '/service-accounts',
    noHeader: true,
    loader: () =>
      import('./ServiceAccountsPage').then(m => <m.ServiceAccountsPage />),
  },
});

export const serviceAccountsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [serviceAccountsPage],
});
